import styled from 'styled-components/native';

const Row = styled.View`
    flex-direction: row;
`;

export default Row;
